import Reflux from 'reflux';
import PermissionActions from 'flux/actions/PermissionActions';
import { Map, List, fromJS } from 'immutable';
import BaseMixin from 'flux/stores/BaseMixin';
import TeamViewActions from 'flux/actions/TeamViewActions';
import EventViewActions from 'flux/actions/EventViewActions';

const onTeamPopulateCompleted = TeamViewActions.populate.completed;
const onEventPopulateCompleted = EventViewActions.populate.completed;

/**
 * Confirm Modal Store
 *
 * Keeps track of confirm visibility
 *
 */
export default Reflux.createStore({
  listenables: [PermissionActions],

  mixins: [BaseMixin],

  init() {
    this.setState(
      Map({
        nameConstants: {},
        loading: true,
      }),
    );

    this.listenTo(onTeamPopulateCompleted, 'onTeamPopulateCompleted');
    this.listenTo(onEventPopulateCompleted, 'onEventPopulateCompleted');
  },

  /**
   * Get object of all permissions
   */
  onPopulateNamesCompleted(permissions) {
    let next = this.getState().set('nameConstants', permissions);

    if (next.get('permissions')) next = this._updatePermissionStatuses(next);

    this.setStateAndTrigger(next);
  },

  onTeamPopulateCompleted(team) {
    this.setInState('teamPermissions', fromJS(team.permissions || []));
    if (this.getInState('eventPermissions'))
      this._updatePermissionsAndTrigger();
  },

  onEventPopulateCompleted(event) {
    this.setInState('eventPermissions', fromJS(event.permissions || []));
    if (this.getInState('teamPermissions')) this._updatePermissionsAndTrigger();
  },

  _updatePermissionsAndTrigger(state) {
    let next = state || this.getState();

    next = next.set(
      'permissions',
      List().concat(next.get('teamPermissions'), next.get('eventPermissions')),
    );
    next = this._updatePermissionStatuses(next);

    next = next.set('loading', false);
    this.setStateAndTrigger(next);
  },

  _updatePermissionStatuses(state) {
    const permissions = state.get('permissions');
    const names = state.get('nameConstants');
    const teamPermissions = state.get('teamPermissions');

    return state.withMutations((st) => {
      st.set('show', this._findPermission(permissions, names.showsFullAccess));
      st.set(
        'schedule',
        this._findPermission(permissions, names.schedulesFullAccess),
      );
      st.set('list', this._findPermission(permissions, names.listsFullAccess));
      st.set('docs', this._findPermission(permissions, names.docsFullAccess));
      st.set(
        'teleprompter',
        this._findPermission(permissions, names.teleprompterFullAccess),
      );
      st.set(
        'overUnder',
        this._findPermission(teamPermissions, names.overUnderFullAccess),
      );

      return st;
    });
  },

  _findPermission(permissions, name) {
    return permissions.find((perm) => {
      if (!perm) return false;
      return perm.get('name') === name;
    });
  },
});
